import * as Amplitude from "@amplitude/analytics-browser";

import {
    MANAGEMENT_AMPLITUDE_API_KEY_CUSTOMER,
    MANAGEMENT_AMPLITUDE_API_KEY_DRIVER_APP,
} from "../../config.management";

// Instance 1: Driver-facing events (existing functionality)
export const driverAppAmplitudeInstance = Amplitude.createInstance();
driverAppAmplitudeInstance.init(MANAGEMENT_AMPLITUDE_API_KEY_DRIVER_APP!, {
    defaultTracking: true,
    instanceName: "Management-DriverApp",
});

// Instance 2: Customer-facing events (orders, purchases)
// This ensures order_edited events are tracked to the same Amplitude project
// as purchase_completed events from the website
export const customerAmplitudeInstance = Amplitude.createInstance();
customerAmplitudeInstance.init(MANAGEMENT_AMPLITUDE_API_KEY_CUSTOMER!, {
    autocapture: false, // Do not auto capture anything here, we will manually capture events
    instanceName: "Management-Customer",
});
